function slider(slider) {
  
  // the current slide
  var current = 2;
  
  // our slider ref
  var slider = slider;
  
  // declare our vars
  var images = [], 
      imageWidth = 0, 
      totalImageWidth = 0, 
      location = 0;
  
  this.update = function() {
    // get the images from the slider element
    // so that we can get the width
    // nb, only get visible images
    images = slider.children('li').filter(function() {
     
      // we literally check for display = none
      // as if we used the :visible filter we'd
      // get nothing
      return $(this).css('display') != 'none';
      
    }).find('img');
                
    // get the width of an image, set 0 if no images
  	imageWidth = (images.length > 0) ? images[0].width + 5 : 0;
        
    // get the total image width
  	totalImageWidth = images.length * imageWidth;
        
    // reset the current and location
    current = 2; location = 1; 
    
    // reset the slider too
    slider.animate ({
        'margin-left': 0
    });
  }
  
  this.next = function() {
  	
    // increment the current index
    var max = images.length - 1;
    
    console.log(current+' '+max); 
    
    if(current >= max) {
        return false;
    } else {
        current += 1;
        transition('next');
    }
    
    // transition the slideshow
  };
  
  this.previous = function() {
  
    console.log(current); 
    
    if(current <= 2) {
      return false;
    } else {
      current -= 1;
      transition('prev');
    }
    
  };
  
  // private transition function
  var transition = function(direction) {
        
    var unit;
    
    // the location needs a default value
    location = imageWidth;
        
    if ( current === 0 ) {
      current = images.length;
      location = totalImageWidth - imageWidth;
      direction = 'next';
    } else if (current - 1 === images.length) {
      current = 1;
      location = 0;
    }
    
    if ( direction && location !== 0 ) {
      unit = (direction == 'next') ? '-=' : '+=';
    }
    
    slider.animate ({
        'margin-left': unit ? (unit + location) : location
    });
  }
}

var sliderObj;